<template>
    <div>
        <span v-if="cardType !== 'unknown' && svgSrc">
            <img :src="svgSrc" alt="card" :style="{ width: width + 'px' }" />
        </span>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = withDefaults(
    defineProps<{
        card?: string;
        width?: number;
    }>(),
    {
        card: '',
        width: 40
    }
);

const cardTypes: Record<string, string> = {
    visa: require('@/assets/images/visa-colored.svg'),
    unionpay: require('@/assets/images/unionpay-colored.svg'),
    mastercard: require('@/assets/images/master-card-colored.svg'),
    jcb: require('@/assets/images/jcb-colored.svg'),
    discover: require('@/assets/images/discover-colored.svg'),
    dinersclub: require('@/assets/images/diners-club-colored.svg'),
    diners: require('@/assets/images/diners-club-colored.svg'),
    'american express': require('@/assets/images/american-express-colored.svg'),
    amex: require('@/assets/images/american-express-colored.svg')
};

const cardType = computed(() => props.card.toLowerCase());

const svgSrc = computed(() => cardTypes[cardType.value] || require('@/assets/images/generic.svg'));
</script>
